import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Footer from '../AdminFooter.js'
import FormInputs from '../CreateFormInputAdmin.js'
import { Navigation } from '../GetEvent.jsx/NavigationAdmin.js'
import RequestHeader from '../GetEvent.jsx/RequestHeaderAdmin.js'
import Header from '../HeaderAdmin.js'
import useFormContext from "./useFormAdminContext.js"
import {
    EVENTS_BASE_URL,
    GUEST_ADMIN
} from '../ApiDetails.js'

const GetEventDetailAdmin = () => {

    const {
        eventFormData,
        getEventById,
        handlepageChange,
        searchAddress,
        isEventOffSite,
        headerRefresh
    } = useFormContext();

    const [isEditing, setIsEditing] = useState(false);

    useEffect(() => {
        var res = window.location.href.split('/');
        eventFormData.eventId = res[res.length - 1]
        getEventById(eventFormData.eventId)
        if (res[res.length - 2] == 'guest') {
            handlepageChange(2);
        } else
            if (res[res.length - 2] == 'comment') {
                handlepageChange(3);
            } else
                if (res[res.length - 2] == 'postevent') {
                    handlepageChange(4);
                }
    }, []);

    const handleSaveChanges = async () => {
        try {
            // Ensure `eventId` and other fields are preserved
            const guestApi = await axios.get(`${EVENTS_BASE_URL}/${eventFormData.eventId}/${GUEST_ADMIN}`);
            const guestData = guestApi.data.guests.map(data => data.fullname).toString();

            // Ensure `eventId` and other fields are preserved
            const updatedEventFormData = {
                ...eventFormData,
                nameOfMem: guestData
            };

            if (isEventOffSite) {
                updatedEventFormData.siteCode = "OFF";
                updatedEventFormData.countryName = "";
                updatedEventFormData.cityName = "";
                updatedEventFormData.stateName = "";
                updatedEventFormData.eventAddress = searchAddress;
                updatedEventFormData.eventVenueName = searchAddress.split(",")[0];
            }

            // Post the updated event data to the API
            const response = await axios.post(EVENTS_BASE_URL, updatedEventFormData);
            if (response.status !== 200) {
                alert('Failed to update the event. Please try again.');
            }
        } catch (error) {
            console.error('Error saving event data:', error);
            alert('An error occurred while saving. Please try again.');
        }
    };

    const content = (
        <form id="getDetailsAdminForm" className="form flex-col">
            <div>
                <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.8/dist/css/bootstrap.min.css" rel="stylesheet"
                    integrity="sha384-QWTKZyjpPEjISv5WaRU9OFeRpok6YctnYmDr5pNlyT2bRjXh0JMhjY6hW+ALEwIH" crossOrigin="anonymous"></link>
                <div className='container-fluid-custom'>
                    <Header key={headerRefresh} />
                    <RequestHeader />
                    <div className="container-fluid">
                        <div className="row m-1 mb-5">
                            <div className="col-md-2 p-0">
                                <Navigation />
                            </div>
                            <FormInputs isEditing={isEditing} />
                        </div>
                    </div>
                    <Footer setIsEditing={setIsEditing} isEditing={isEditing} handleSaveChanges={handleSaveChanges} />
                </div>
            </div>
        </form>
    )

    return content
}

export default GetEventDetailAdmin